import Sanitizer from '../../extras/extensions/js/Sanitizer';

const { sanitizeUrl } = Sanitizer;

export { sanitizeUrl };
